import { Separator } from "~/components/ui/separator";

export function PanelSectionSeparator() {
  return <Separator />;
}
